import {Injectable} from "@angular/core";
import {Subject} from "rxjs";


@Injectable()
export class OutletService {

  private _manageoutlets = new Subject<string>();
  _manageoutlets$ = this._manageoutlets.asObservable();

  private defaultOutletAction = 'ok';


  manageOutletActions(action:string){
    this._manageoutlets.next(action?action:this.defaultOutletAction);
  }

}
